module.exports = __webpack_public_path__ + "img/Group 2955.1c74095f.svg";